import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import UserContext from "../../contexts/UserContext";
import Preloader from "../../components/Preloader";
import NetworkError from "../../components/NetworkError";
import { textes } from "../../constants/textes";
import { config } from "../../constants/config";
import Pagination from "../../components/Pagination";
import Search from "../Search";
import Revendeur from "./revendeur";

export default function Revendeurs() {
    // states
    const { user, logoutUser } = useContext(UserContext);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);


    const [elementsList, setElementsList] = useState([]);
    const [nbpage, setNbpage] = useState(1);
    const [nbelement, setNbelement] = useState(0);
    const [page, setPage] = useState(0);

    const [isSearch, setIsSearch] = useState(false);
    const [chaine, setChaine] = useState('');

    const getElementsList = async (p) => {
        setLoading(true);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.secure.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            // body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)
        await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/users?type=revendeur&limit=${config.secure.limit}&page=${p + 1}&etat=1,2,3,4,5,6,7,8,9`, requestOptions).then((response) => {
            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data?.body?.data);
                    if (data?.head) {
                        let clientarray = [];

                        clientarray = data?.body?.data;

                        setElementsList(clientarray);
                        setNbpage(data?.body?.pages);
                        setNbelement(data?.body?.length);
                        setLoading(false);
                    } else {
                        if (data?.body?.data?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            setError(true);
                            setLoading(false);
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                setError(true);
                setLoading(false);
            }

        }).catch((err) => {
            // console.log("error", err);
            setError(true);
            setLoading(false);
        });

    }

    const autoSearchElement = async (c) => {
        setPage(0);
        if ((c && !isSearch) || (c && isSearch)) {
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
            myHeaders.append("token", config.secure.PUBLICKEY);
            myHeaders.append("apikey", user.token);
            myHeaders.append("cpte", user.code);
            myHeaders.append("prof", user.profil);
            myHeaders.append("conn", user.espace);


            var requestOptions = {
                method: 'GET',
                headers: myHeaders,
                // body: urlencoded,
                redirect: 'follow'
            };

            // console.log("data send", urlencoded)

            await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/users?type=revendeur&crit=${c}&etat=1,2,3,4,5,6,7,8,9`, requestOptions).then((response) => {
                if (response?.status === 200) {
                    response.json().then(async (data) => {
                        if (data?.head) {
                            // console.log("resonse jsondecode", data);
                            let clientarray = [];
                            clientarray = data?.body?.data;

                            setElementsList(clientarray);
                            setNbpage(data?.body?.pages);
                            setNbelement(data?.body?.length);
                            // setLoading(false);
                        } else {
                            if (data?.body?.data?.msg === "expiredsession") {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                setError(true);
                            }
                            // setLoading(false);
                        }
                    });
                } else if (response?.status === 401) {
                    logoutUser();
                    navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                } else {
                    setError(true);
                    // setLoading(false);
                }

            }).catch((err) => {
                // console.log("error", err);
                setError(true);
                // setLoading(false);
            });
        } else if (c !== "" && isSearch) {
            setIsSearch(false);
            getElementsList(page);
        } else {
            setIsSearch(false);
            getElementsList(page);
        }
    }


    // comportements
    useEffect(() => {
        getElementsList(page);
    }, []);

    useEffect(() => {
        const stimeout = setTimeout(() => {
            autoSearchElement(chaine);
        }, 1000);

        return () => clearTimeout(stimeout);
    }, [chaine]);


    // affichages
    return (
        <div className="row">
            <div className="col-md-12">
                {loading && <Preloader />}
                {!loading && error && <NetworkError />}
                {!loading && !error && (
                    <div
                        className="col-md-12"
                        style={{
                            paddingTop: 8,
                            borderTop: "1px solid #ddd",
                            borderRadius: 8,
                        }}
                    >
                        <div className="row">
                            <div className="col-md-12 mb-3">
                                <Search
                                    chaine={chaine}
                                    setChaine={setChaine}
                                    // search={searchEmployee}
                                    placeholder="Rechercher..."
                                />
                            </div>
                            <div className="col-md-12 mb-3">
                                <div className="card shadow mb-4">
                                    <div className="card-header py-3">
                                        <h6 className="m-0 ">Liste des revendeurs du système</h6>
                                    </div>
                                    <div className="card-body">
                                        <div className="table-responsive mb-3">
                                            <table className="mb-0 table table-bordered">
                                                <thead className="bg-primary">
                                                    <tr className="bg-primary text-white">
                                                        <th className="text-center">#</th>
                                                        <th>Revendeur</th>
                                                        <th>Numéro</th>
                                                        <th>Solde</th>
                                                        <th>Retenue au retrait</th>
                                                        {/* <th>{textes.fr.statelabel}</th> */}
                                                        <th>{textes.fr.addeddatelabel}</th>
                                                        <th className="text-center">
                                                            {textes.fr.actionlabel}
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {elementsList.length === 0 && (
                                                        <tr style={{ borderStyle: "none" }}>
                                                            <th colSpan={7} className="text-center">
                                                                Aucun revendeur trouvé
                                                            </th>
                                                        </tr>
                                                    )}
                                                    {elementsList.length > 0 &&
                                                        elementsList?.map((item, index) => (
                                                            <Revendeur
                                                                user={item}
                                                                position={(config.secure.limit * page) + index}
                                                                key={index}
                                                            />
                                                        ))}
                                                </tbody>
                                            </table>
                                        </div>
                                        <Pagination
                                            nbpage={nbpage}
                                            getList={getElementsList}
                                            page={page}
                                            setPage={setPage}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
